//import navItems from "lib/nav-items";
//import NavigationCards from "../../../navigation/navigation-cards/navigation-cards";
import { useState } from "react";
import ReportSection from "../../../reports-common/report-section/report-section";
import { IReportSectionProps } from "../../../reports-common/report-section/report-section.props";
import { IRequestModel } from "@interfaces/reports/reports-common.interfaces";
import { IStorageInTenantReportDetails, IStorageInTenantReportItem } from "@interfaces/reports/storage-reports.interfaces";
import SizeCell from "components/reports-common/report-results-grid-cells/size-cell/size-cell";
import StoragePercentageCell from "components/reports-common/report-results-grid-cells/storage-percentage-cell/storage-percentage-cell";
import StorageInTenantReportSummary from "components/reports/storage/storage-in-tenant-report/storage-in-tenant-report-summary";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import WorkspaceLinkCell from "components/reports-common/report-results-grid-cells/workspace-link-cell/workspace-link-cell";
import { getSharePointTemplateKey, getWorkspaceTypeKey } from "lib/workspaces";
import { IPersonalSiteFilter, ITableColumn, IWorkspaceFilter } from "@interfaces/common.interfaces";
import PersonalSiteFilter from "components/controls/personal-site-filter/personal-site-filter";
import DateTimeCell from "components/reports-common/report-results-grid-cells/date-time-cell/date-time-cell";
import { isWorkspaceFilterValid } from "lib/request-model-validation-helper";
import WorkspaceFilter from "components/controls/workspace-filter/workspace-filter";

//import StorageInTenantReportDetails from "components/reports/report-details/storage/storage-in-tenant-report-details";


// TODO: Somewhere central. e.g. in the navitems????
const reportUrl: string = "/api/reports/storage-in-tenant";


export default function StorageInTenantReport() {

  const { t } = useL10n<ILocaleStrings>();
  const [model, setModel] = useState<IRequestModel>({});
  const [personalSiteFilter] = useState<IPersonalSiteFilter>({ includeWorkspaces: true, includeOneDrive: false });
  const [workspaceFilter, setWorkspaceFilter] = useState<IWorkspaceFilter>({
    applyFilter: false
  });
  
  const cols: Array<ITableColumn<IStorageInTenantReportItem>> = [
    {
      key: "workspaceName", label: t("ppaWorkspace"), showInGrid: true, showInExport: true, defaultWidth: 200,
      renderCell: (key: string, item: IStorageInTenantReportItem) => (<WorkspaceLinkCell name={item.workspaceName} url={item.workspaceUrl} template={item.workspaceTemplate} type={item.workspaceType} />)
    },
    { key: "workspaceUrl", label: t("ppaWorkspaceUrl"), showInGrid: false, showInExport: true },
    { key: "workspaceType", label: t("ppaWorkspaceType"), showInGrid: true, showInExport: true, defaultWidth: 150 },
    {
      key: "lastModified", label: t("lastModified"), showInGrid: true, showInExport: true, defaultWidth: 150,
      renderCell: (key: string, item: IStorageInTenantReportItem) => (<DateTimeCell columnId={key} item={item} pattern="PPp" />)
    },
    {
      key: "totalSize", label: t("ppaTotalSize"), showInGrid: true, showInExport: false, defaultWidth: 200,
      renderCell: (key: string, item: IStorageInTenantReportItem) => (<SizeCell value={item.totalSize} valueUnits="B" />)
    },
    { key: "totalSize", label: t("ppaTotalSizeBytes"), showInGrid: false, showInExport: true },
    {
      key: "percentageOfQuota", label: t("ppaPercentageOfQuota"), showInGrid: true, showInExport: true, defaultWidth: 120,
      renderCell: (key: string, item: IStorageInTenantReportItem, details: IStorageInTenantReportDetails) => (
        <StoragePercentageCell
          percentageUsed={item.percentageOfQuota}
          usedValue={item.totalSize}
          usedValueUnits="B"
          maxValue={details.storageQuotaMB}
          maxValueUnits="MB" />)
    },
  ];

  const onPersonalSiteFilterChange = (value?: IPersonalSiteFilter) => {
    setModel({
      ...model,
      personalSiteFilter: {
        includeWorkspaces: value?.includeWorkspaces,
        includeOneDrive: value?.includeOneDrive
      }
    });
  }

  const onWorkspaceFilterChange = (value?: IWorkspaceFilter) => {
    setWorkspaceFilter({
      applyFilter: value?.applyFilter || false,
      filter: value?.filter
    });
    setModel({
      ...model,
      workspaceFilter: value?.applyFilter ?
        {
          property: value?.filter?.property,
          operator: value?.filter?.operator,
          value: value?.filter?.value
        }
        : undefined
    });
  };

  // Model is valid if at least one of the properties is set to true.
  const isModelValid = (): boolean => {
    const hasPersonalSiteFilter = (model.personalSiteFilter?.includeWorkspaces || model.personalSiteFilter?.includeOneDrive) === true;

    return hasPersonalSiteFilter && isWorkspaceFilterValid(workspaceFilter.applyFilter, model.workspaceFilter);
  }

  const reportSectionProps: IReportSectionProps<IStorageInTenantReportItem, IStorageInTenantReportDetails> = {
    columns: cols,
    summaryComponent: <StorageInTenantReportSummary temp="the temp prop" />,
    reportUrl: reportUrl,
    model: model,
    isModelValid: isModelValid(),
    noItemsMessage: t("ppaStorageInTenantReportNoItemsMessage"),
    defaultExportFilenamePrefix: "ppaStorageInTenantReportDefaultExportFilenamePrefix"
  }

  return (
    <ReportSection {...reportSectionProps}>
      <WorkspaceFilter model={workspaceFilter} onChange={onWorkspaceFilterChange} />
      <PersonalSiteFilter model={personalSiteFilter} onChange={onPersonalSiteFilterChange} />
    </ReportSection>
  );
}
